(function () {
  "use strict";

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  ready(function () {
    try {
var selector = [
  ".haus-motion",
  ".haus-cascade",
  ".haus-curtain",
  ".haus-text-rise",
  ".haus-button-enter",
  ".haus-line-draw",
  ".haus-line-draw-vertical",
  ".haus-title-lift",
  ".haus-stage-left",
  ".haus-stage-right",
  ".haus-stage-grid",
  ".haus-cta-snap",
  ".haus-eyebrow-slice",
  ".haus-card-stage",
  ".haus-image-door"
].join(",");

      var animatedItems = document.querySelectorAll(selector);

      if ("IntersectionObserver" in window && animatedItems.length) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                observer.unobserve(entry.target);
              }
            });
          },
{
  threshold: 0.05,
  rootMargin: "0px 0px -10px 0px"
}
        );

        animatedItems.forEach(function (item) {
          observer.observe(item);
        });
      } else {
        animatedItems.forEach(function (item) {
          item.classList.add("is-visible");
        });
      }

      /* Spotlight cursor effect */
      var spotlightSections = document.querySelectorAll(".haus-spotlight, .haus-manifesto");

      spotlightSections.forEach(function (section) {
        section.addEventListener(
          "mousemove",
          function (event) {
            var rect = section.getBoundingClientRect();
            var x = ((event.clientX - rect.left) / rect.width) * 100;
            var y = ((event.clientY - rect.top) / rect.height) * 100;

            section.style.setProperty("--haus-mouse-x", x + "%");
            section.style.setProperty("--haus-mouse-y", y + "%");
          },
          { passive: true }
        );
      });

      /* Magnetic buttons, opt-in only */
      var magneticItems = document.querySelectorAll(".haus-magnetic");

      magneticItems.forEach(function (item) {
        item.addEventListener("mousemove", function (event) {
          var rect = item.getBoundingClientRect();
          var x = event.clientX - rect.left - rect.width / 2;
          var y = event.clientY - rect.top - rect.height / 2;

          item.style.transform =
            "translate3d(" + x * 0.14 + "px, " + y * 0.2 + "px, 0)";
        });

        item.addEventListener("mouseleave", function () {
          item.style.transform = "translate3d(0, 0, 0)";
        });
      });
    } catch (error) {
      console.warn("HAUS motion safely stopped:", error);
    }
  });
})();
/* HAUS Stage Motion Rescue
   Keeps stage-left/right working inside Shopify's dynamic editor
*/
(function () {
  "use strict";

  var stageSelector = ".haus-stage-left, .haus-stage-right";
  var stageObserver = null;
  var scanQueued = false;

  function getStageObserver() {
    if (stageObserver) return stageObserver;

    if (!("IntersectionObserver" in window)) {
      return null;
    }

    stageObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            stageObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -40px 0px"
      }
    );

    return stageObserver;
  }

  function scanStage(root) {
    root = root || document;

    var items = [];

    if (root.matches && root.matches(stageSelector)) {
      items.push(root);
    }

    root.querySelectorAll(stageSelector).forEach(function (item) {
      items.push(item);
    });

    items.forEach(function (item) {
      if (item.dataset.hausStageReady === "true") return;

      item.dataset.hausStageReady = "true";

      var observer = getStageObserver();

      if (observer) {
        observer.observe(item);
      } else {
        item.classList.add("is-visible");
      }
    });
  }

  function queueStageScan(root) {
    if (scanQueued) return;

    scanQueued = true;

    window.requestAnimationFrame(function () {
      scanStage(root || document);
      scanQueued = false;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scanStage(document);
    });
  } else {
    scanStage(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    scanStage(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    scanStage(event.target);
  });

  if ("MutationObserver" in window) {
    new MutationObserver(function () {
      queueStageScan(document);
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    });
  }
})();
/* HAUS mobile fail-safe reveal */
window.addEventListener("load", function () {
  setTimeout(function () {
    if (window.innerWidth <= 749) {
      document
        .querySelectorAll(
          ".haus-motion, .haus-text-rise, .haus-title-lift, .haus-stage-left, .haus-stage-right, .haus-stage-grid, .haus-cascade, .haus-cta-snap, .haus-image-door, .haus-curtain"
        )
        .forEach(function (el) {
          var rect = el.getBoundingClientRect();

          if (rect.top < window.innerHeight + 400) {
            el.classList.add("is-visible");
          }
        });
    }
  }, 700);
});